export enum FileExtensionTypes {
    // We support preview for file extension types list below except for others.
    Audio,

    Image,

    Pdf,

    Text,

    Video,

    Wac,

    Others,
}
